import { render, staticRenderFns } from "./Novo-banco.vue?vue&type=template&id=3c79d2c2&scoped=true&"
import script from "./Novo-banco.vue?vue&type=script&lang=js&"
export * from "./Novo-banco.vue?vue&type=script&lang=js&"
import style0 from "./Novo-banco.vue?vue&type=style&index=0&id=3c79d2c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79d2c2",
  null
  
)

export default component.exports